module.exports = __webpack_public_path__ + "img/28.2d8e94a5.jpg";